import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Extrai a mensagem de erro de uma resposta de API
 * Trata tanto erros simples quanto arrays de validação do Pydantic
 */
export function getErrorMessage(error, defaultMessage = "Ocorreu um erro") {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return defaultMessage;
  }
  
  // Se for uma string, retorna diretamente
  if (typeof detail === "string") {
    return detail;
  }
  
  // Se for um array de erros de validação do Pydantic
  if (Array.isArray(detail)) {
    return detail.map(err => {
      if (typeof err === "string") return err;
      if (err.msg) return err.msg;
      return JSON.stringify(err);
    }).join(", ");
  }
  
  // Se for um objeto com msg
  if (detail.msg) {
    return detail.msg;
  }
  
  return defaultMessage;
}
